/* FBS Emirates — Theme JS */
(function () {
  'use strict';

  /* ── Header scroll effect ─────────────────────── */
  const header = document.querySelector('.site-header');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Mobile drawer ────────────────────────────── */
  const drawerOpen  = document.getElementById('drawer-open');
  const drawerClose = document.getElementById('drawer-close');
  const drawer      = document.getElementById('mobile-drawer');
  const backdrop    = drawer?.querySelector('.drawer-backdrop');

  const openDrawer  = () => { drawer?.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const closeDrawer = () => { drawer?.classList.remove('open'); document.body.style.overflow = ''; };

  drawerOpen?.addEventListener('click', openDrawer);
  drawerClose?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  /* ── Accordion ────────────────────────────────── */
  document.querySelectorAll('.acc-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.acc-trigger').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
        t.nextElementSibling?.classList.remove('open');
      });
      if (!expanded) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.nextElementSibling?.classList.add('open');
      }
    });
  });

  /* ── Gallery thumbnails ───────────────────────── */
  const mainImg = document.querySelector('.gallery-main-img');
  document.querySelectorAll('.g-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.g-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.querySelector('img')?.src;
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 200);
      }
    });
  });

  /* ── Quantity selector ────────────────────────── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-ctrl')?.querySelector('.qty-val');
      if (!input) return;
      let v = parseInt(input.value) || 1;
      if (btn.dataset.action === 'dec') v = Math.max(1, v - 1);
      if (btn.dataset.action === 'inc') v = Math.min(99, v + 1);
      input.value = v;
    });
  });

  /* ── Variant selector ─────────────────────────── */
  document.querySelectorAll('.var-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavailable')) return;
      const group = btn.closest('.variant-opts');
      group?.querySelectorAll('.var-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const vid = btn.dataset.variantId;
      const hiddenId = document.getElementById('variant-id-input');
      if (hiddenId && vid) hiddenId.value = vid;
    });
  });

  /* ── Add to cart ──────────────────────────────── */
  document.querySelectorAll('.atc-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = form.querySelector('.qty-val')?.value || 1;
      if (!variantId) return;

      const origText = btn.innerHTML;
      btn.innerHTML = 'Adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });
        if (!res.ok) throw new Error();

        btn.innerHTML = '✓ Added to Cart!';
        btn.style.background = '#059669';
        refreshCartCount();

        setTimeout(() => {
          btn.innerHTML = origText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);
      } catch {
        btn.innerHTML = 'Error — Retry';
        btn.style.background = '#DC2626';
        setTimeout(() => {
          btn.innerHTML = origText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);
      }
    });
  });

  async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      document.querySelectorAll('.cart-bubble').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('visible', cart.item_count > 0);
      });
    } catch {}
  }
  refreshCartCount();

  /* ── Scroll reveal ────────────────────────────── */
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

  document.querySelectorAll('.reveal, .stagger-children').forEach(el => revealObs.observe(el));

  /* ── Count-up animation ───────────────────────── */
  const countObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.count);
      if (isNaN(target)) return;
      const suffix = el.dataset.suffix || '';
      const duration = 1800;
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target) + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      countObs.unobserve(el);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-count]').forEach(el => countObs.observe(el));

  /* ── Announcement shimmer loop ────────────────── */
  // Already handled via CSS animation

})();
